import { forwardRef, Ref } from 'react';

import { Stack, StackProps, styled } from '@mui/material';

import { FabMenuItem, fabMenuItemClasses } from '../components/FabMenu';
import { forMobile } from '../utils/media-queries';

export const CourseListWrappper = styled(
  forwardRef((props: StackProps, ref: Ref<HTMLDivElement>) => <Stack gap={3} py={4} {...props} ref={ref} />)
)(({ theme }) => ({
  [forMobile(theme)]: {
    padding: theme.spacing(4),
  },
}));

export const CloseFabMenuItem = styled(FabMenuItem)(({ theme }) => ({
  [`.${fabMenuItemClasses.icon}`]: {
    color: theme.palette.error[800],
  },
  [`.${fabMenuItemClasses.text}`]: {
    color: theme.palette.error[800],
  },
}));
